module.exports = __webpack_public_path__ + "static/img/6.a5153b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/eng/6.png
// module id = ZFUB
// module chunks = 0